export default {
    config: {
        defaultWidth: 160
    },
    default: {
        label: 'Box Size'
    },
    unique: [],
    sort: 'version.size.footprint',
    lang: {
        name: 'Box Size',
        category: ['User', 'Collection'],
        description: 'Storage box dimensions and weight of the owned version (Deep Sync data).',
        views: ['list', 'sheet'],
    },
    filters: ['version.size.width', 'version.size.length', 'version.size.depth', 'version.size.weight', 'version.size.footprint']
}
